import PropTypes from "prop-types";
import React from "react";
import { Button, ButtonToolbar, Form, FormControl } from "react-bootstrap";
import { defineMessages, FormattedMessage } from "react-intl";

import genericTranslations from "../../../utils/genericTranslations.js";

export const MODULE = "BUS_JOURNEYS";
export const MIN_BUS_JOURNEY_MAX_DISTANCE = 200;

const messages = defineMessages({
  busJourneyMaxDistance: {
    id: "modules.Settings.components.SettingsForm.busJourneyMaxDistance",
    description: "Bus journey max distance label.",
    defaultMessage: "Buses max distance (meters)",
  },
  busJourneyMaxDistanceHelp: {
    id: "modules.Settings.components.SettingsForm.busJourneyMaxDistanceHelp",
    description: "Bus journey max distance helper text.",
    defaultMessage:
      "Maximum search radius (in meters) used to find nearby busses.",
  },
});

const SettingsForm = ({
  handleChange,
  handleSubmit,
  errors,
  isSubmitting,
  values,
  isEditing,
  onEdit,
  onCancel,
  resetForm,
}) => (
  <Form onSubmit={handleSubmit}>
    <Form.Group controlId="busJourneyMaxDistance" className="mb-3">
      <Form.Label>
        <FormattedMessage {...messages.busJourneyMaxDistance} />
      </Form.Label>
      <FormControl
        name="busJourneyMaxDistance"
        type="number"
        min={MIN_BUS_JOURNEY_MAX_DISTANCE}
        step={1}
        autoComplete="off"
        disabled={!isEditing}
        value={values.busJourneyMaxDistance}
        onChange={handleChange}
        isInvalid={!!errors.busJourneyMaxDistance}
      />
      <Form.Text>
        <FormattedMessage {...messages.busJourneyMaxDistanceHelp} />
      </Form.Text>
      <Form.Control.Feedback type="invalid">
        {errors.busJourneyMaxDistance}
      </Form.Control.Feedback>
    </Form.Group>

    <hr />

    <Form.Group controlId="formActions" className="mb-3">
      <ButtonToolbar>
        {isEditing ? (
          <>
            <Button
              variant="light"
              className="me-2"
              onClick={() => {
                resetForm();
                onCancel();
              }}
              disabled={isSubmitting}
            >
              <FormattedMessage {...genericTranslations.cancel} />
            </Button>
            <Button
              type="submit"
              variant="primary"
              disabled={isSubmitting || Object.keys(errors).length > 0}
            >
              <FormattedMessage {...genericTranslations.save} />
            </Button>
          </>
        ) : (
          <Button variant="primary" onClick={onEdit}>
            <FormattedMessage {...genericTranslations.edit} />
          </Button>
        )}
      </ButtonToolbar>
    </Form.Group>
  </Form>
);

SettingsForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    busJourneyMaxDistance: PropTypes.string,
  }),
  values: PropTypes.shape({
    busJourneyMaxDistance: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }),
};

export default SettingsForm;
